import { render, staticRenderFns } from "./LoadAds.vue?vue&type=template&id=7d2321e2&lang=html&"
import script from "./LoadAds.vue?vue&type=script&lang=js&"
export * from "./LoadAds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports